import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
const MatTabs = ({tabs,onChange,value}) => {
    return (
    <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
            value={value}
            onChange={onChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            centered>
                {tabs.map(item=><Tab label={item.label} index={item.index}/>)}
        </Tabs>
    </Box>);
}

export default MatTabs;